import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout } from "@/components/LegalLayout";

export const Route = createFileRoute("/regulamin")({
  component: Terms,
  head: () => ({
    meta: [
      { title: "Regulamin świadczenia usług — SkuteczneStrony" },
      {
        name: "description",
        content:
          "Regulamin świadczenia usług projektowych i developerskich SkuteczneStrony — zasady współpracy, oferta, płatności, reklamacje i odpowiedzialność.",
      },
      { property: "og:title", content: "Regulamin — SkuteczneStrony" },
      {
        property: "og:description",
        content: "Zasady korzystania z serwisu i świadczenia usług przez SkuteczneStrony.",
      },
      { property: "og:url", content: "https://skutecznestrony.com/regulamin" },
      { property: "og:type", content: "article" },
      { name: "robots", content: "index, follow" },
    ],
    links: [{ rel: "canonical", href: "https://skutecznestrony.com/regulamin" }],
  }),
});

function Terms() {
  return (
    <LegalLayout title="Regulamin świadczenia usług" updated="23 czerwca 2026">
      <h2>§ 1. Postanowienia ogólne</h2>
      <ol>
        <li>
          Regulamin określa zasady korzystania z serwisu{" "}
          <strong>https://skutecznestrony.com</strong> oraz świadczenia usług projektowych
          i developerskich przez SkuteczneStrony (dalej: „Usługodawca").
        </li>
        <li>
          Kontakt z Usługodawcą:{" "}
          <a href="mailto:kontakt@skutecznestrony.com">kontakt@skutecznestrony.com</a>.
        </li>
        <li>
          Klientem (dalej: „Klient") może być osoba fizyczna prowadząca działalność gospodarczą,
          osoba prawna lub jednostka organizacyjna posiadająca zdolność prawną.
        </li>
      </ol>

      <h2>§ 2. Zakres usług</h2>
      <ol>
        <li>
          Usługodawca świadczy usługi w zakresie: projektowania stron internetowych, sklepów
          e-commerce, aplikacji webowych, wdrożeń SEO/Core Web Vitals oraz integracji z systemami
          zewnętrznymi.
        </li>
        <li>
          Zakres, harmonogram i wynagrodzenie ustalane są indywidualnie w ofercie lub umowie
          przesłanej drogą elektroniczną.
        </li>
      </ol>

      <h2>§ 3. Demo i etap przedumowny</h2>
      <ol>
        <li>
          Usługodawca może udostępnić Klientowi <strong>darmowe demo</strong> w ciągu 72 godzin od
          akceptacji briefu. Demo ma charakter poglądowy i nie stanowi oferty handlowej w rozumieniu
          art. 66 § 1 Kodeksu cywilnego.
        </li>
        <li>
          Demo pozostaje własnością Usługodawcy do momentu zawarcia umowy i opłacenia pierwszej
          transzy wynagrodzenia.
        </li>
      </ol>

      <h2>§ 4. Zawarcie umowy i wynagrodzenie</h2>
      <ol>
        <li>
          Umowa zostaje zawarta z chwilą obustronnej akceptacji oferty (np. potwierdzenia e-mail
          lub podpisania dokumentu).
        </li>
        <li>
          Standardowy model rozliczeń: <strong>50% zaliczki</strong> przed rozpoczęciem prac,
          <strong> 50% po wdrożeniu</strong> i akceptacji końcowej. Inne warunki wymagają zapisu
          w umowie.
        </li>
        <li>
          Ceny prezentowane w Serwisie (np. pakiety START, GROWTH, INFINITY) są cenami netto. Do
          każdej faktury doliczany jest podatek VAT zgodnie z obowiązującymi przepisami.
        </li>
      </ol>

      <h2>§ 5. Odpowiedzialność</h2>
      <ol>
        <li>
          Usługodawca odpowiada za należyte i terminowe wykonanie usług zgodnie z zaakceptowanym
          zakresem prac.
        </li>
        <li>
          Usługodawca nie ponosi odpowiedzialności za przerwy w działaniu wynikające z awarii
          dostawców infrastruktury, działań siły wyższej, ataków DDoS ani za szkody pośrednie,
          w tym utracone korzyści.
        </li>
        <li>
          Łączna odpowiedzialność Usługodawcy z tytułu umowy jest ograniczona do wysokości
          wynagrodzenia netto za dany etap prac.
        </li>
      </ol>

      <h2>§ 6. Prawa autorskie</h2>
      <ol>
        <li>
          Z chwilą zapłaty pełnego wynagrodzenia Usługodawca przenosi na Klienta majątkowe prawa
          autorskie do utworów wytworzonych w ramach umowy, na polach eksploatacji niezbędnych
          do korzystania z efektu prac.
        </li>
        <li>
          Usługodawca zachowuje prawo do prezentowania efektów prac w portfolio oraz w materiałach
          marketingowych, chyba że strony postanowią inaczej w umowie.
        </li>
        <li>
          Komponenty pochodzące z bibliotek open source pozostają udostępnione na licencjach ich
          autorów.
        </li>
      </ol>

      <h2>§ 7. Reklamacje</h2>
      <ol>
        <li>
          Reklamacje należy zgłaszać na adres{" "}
          <a href="mailto:kontakt@skutecznestrony.com">kontakt@skutecznestrony.com</a> w terminie
          14 dni od stwierdzenia nieprawidłowości.
        </li>
        <li>
          Usługodawca rozpatruje reklamację w terminie 14 dni roboczych od jej otrzymania.
        </li>
      </ol>

      <h2>§ 8. Pozasądowe sposoby rozstrzygania sporów</h2>
      <p>
        Spory wynikłe z umowy strony będą rozstrzygać polubownie. W razie braku porozumienia, sądem
        właściwym jest sąd właściwy dla siedziby Usługodawcy. Konsumenci mogą skorzystać z
        platformy ODR Komisji Europejskiej:{" "}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
          ec.europa.eu/consumers/odr
        </a>
        .
      </p>

      <h2>§ 9. Postanowienia końcowe</h2>
      <ol>
        <li>
          W sprawach nieuregulowanych regulaminem stosuje się przepisy prawa polskiego,
          w szczególności Kodeksu cywilnego.
        </li>
        <li>
          Usługodawca zastrzega sobie prawo do zmiany regulaminu z ważnych przyczyn (m.in.
          zmiana przepisów prawa, zmiana zakresu usług). Aktualna wersja obowiązuje od daty
          publikacji.
        </li>
      </ol>
    </LegalLayout>
  );
}
